import styled from '@/styles';

export const LinkWrapper = styled('div', {
  margin: '-16px 0 12px',

  display: 'flex',
  flexDirection: 'column',
});
